import styled from "styled-components";

export const SearchableDropdownWrapper = styled.div`
  position: relative;
  width: 200px;
`;

export const DropdownInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &::placeholder {
    color: #999;
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin: 0;
  padding: 0;
  list-style: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const DropdownItem = styled.li<{ $isSelected: boolean }>`
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  background-color: ${(props) => (props.$isSelected ? "#f8f9fa" : "white")};

  &:hover {
    background-color: #e9ecef;
  }

  &:last-child {
    border-bottom: none;
  }

  ${(props) =>
    props.$isSelected &&
    `
    font-weight: 600;
    color: #007bff;
  `}
`;
